var getPaperFeeApplicable = function (data) { var _a; return (_a = data === null || data === void 0 ? void 0 : data.paperFeeApplicable) !== null && _a !== void 0 ? _a : null; };
export default getPaperFeeApplicable;
